var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0117 3.3667V1.85498L8 5.6167L1.98828 1.85498V3.3667L8 7.09326L14.0117 3.3667ZM14.0117 0.343262C14.4102 0.343262 14.75 0.495605 15.0312 0.800293C15.3359 1.10498 15.4883 1.45654 15.4883 1.85498V10.855C15.4883 11.2534 15.3359 11.605 15.0312 11.9097C14.75 12.2144 14.4102 12.3667 14.0117 12.3667H1.98828C1.58984 12.3667 1.23828 12.2144 0.933594 11.9097C0.652344 11.605 0.511719 11.2534 0.511719 10.855V1.85498C0.511719 1.45654 0.652344 1.10498 0.933594 0.800293C1.23828 0.495605 1.58984 0.343262 1.98828 0.343262H14.0117Z",
    fill: "black",
    fillOpacity: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mailIcon.96e4611502d2d617bfe5e19f3e0dc10a.svg";
export { ForwardRef as ReactComponent };